import { Injectable } from '@angular/core';
import { fromEvent, Observable, Subject, Subscription } from 'rxjs';
import { IAppUser, INavItem } from 'src/app/models';
import { IBusinessUnit, IBusinessUnitRole } from 'src/app/modules/business-units/models';
import { IDeal } from 'src/app/modules/deals/models';
import { CognitoUser, UserSettings } from 'src/app/modules/redux';
import { IDealCard } from 'src/app/modules/shared/models';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class DataService {

  // All BUs the user has access to
  businessUnits: IBusinessUnit[] = [];


  // The currently selected BU (from a user profile perspective, this is not the selected BU while Admin is browsing BUs)
  currentBusinessUnit!: IBusinessUnit;
  currentBusinessUnitProfile!: string;

  // current user info
  private currentUser?: UserSettings;

  // current employee info / role / permissions

  currentEmployeeId!: string;
  currentEmployeeRole?: IBusinessUnitRole;
  currentEmployeePermissions: string[] = [];

  // main navigation
  navItems: INavItem[] =[];


  // deal data
  selectedDealId?: string;
  selectedDeal?: IDealCard;
  dealTeamRole?: IBusinessUnitRole;
  dealTeamPermissions: string[] = [];
  dealTabs: INavItem[] = [];

  // debug
  debugMode : boolean = true;


  // Selected business Unit (for ADMIN ONLY)
  adminSelectedBusinessUnitId: string | null = null;
  adminSelectedBusinessUnit: IBusinessUnit | null = null; 


  // set current BusinessUnit
  public setCurrentBusinessUnit(bu: IBusinessUnit) {
    this.currentBusinessUnit = bu;
    this.currentBusinessUnit$.next(bu);

    Sentry.setTags({
      "business-unit-id": bu.businessUnitId,
      "business-unit-name": bu.displayName,
      "business-unit-slug": bu.slug,
    });
  }

  public setSelectedAdminBusinessUnit (bu: IBusinessUnit | null) {
    this.adminSelectedBusinessUnitId = bu?.businessUnitId || null;
    this.adminSelectedBusinessUnit = bu;
    Sentry.setTags({
      "admin-selected-business-unit-id": bu?.businessUnitId || "none",
    });
  }










  // permissions
  public setEmployeePermissionsByRole(role: IBusinessUnitRole | undefined = undefined) {
    this.currentEmployeeRole = role;
    this.setEmployeeRolePermissions(role?.permissions || []);
  }

  public setEmployeeRolePermissions(permissions: string[]) {
    this.currentEmployeePermissions = permissions || [];
    this.permissionsUpdated.next(null);
  }

  public setDealTeamPermissionsByRole(role: IBusinessUnitRole | undefined = undefined) {
    this.dealTeamRole = role;
    this.setDealTeamPermissions(role?.permissions || []);
  }

  public setDealTeamPermissions(permissions: string[]) {
    this.dealTeamPermissions = permissions || [];
    this.permissionsUpdated.next(null);
  }

  public setAppUser(user: UserSettings) { this.currentUser = user; }

  public getAppUser = (): UserSettings | undefined => this.currentUser;

  // events
  public permissionsUpdated = new Subject<any>();

  getDealId = () : string => this.selectedDealId || '';
  getDeal = (): IDealCard | undefined => this.selectedDeal;
  resetDealData = (): void => {
    this.selectedDealId = undefined;
    this.selectedDeal = undefined;
    this.dealTabs = [];
    this.setDealTeamPermissionsByRole();
  }



  // window size
  screenWidth: number = window.innerWidth;
  screenHeight: number = window.innerHeight;

  resizeSubscription!: Subscription;

  constructor() {
    this.resizeSubscription = fromEvent(window, 'resize')
      .subscribe(() => {
        // console.log("new resize event", window.innerWidth, window.innerHeight);
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
      });
   }

  getBuSlug = () : string =>  this.currentBusinessUnit?.slug || '';
  getBuId = () : string => this.currentBusinessUnit?.businessUnitId || '';
  getScreenWidth = () : number => this.screenWidth;

  // selected BU admin function
  getSelectedBuId = () : string => this.adminSelectedBusinessUnitId || '';

   
  /**
   * subscriptions
   */
  // public config$!: Subject<any>; 
  public cognitoUser$: Subject<CognitoUser> = new Subject<CognitoUser>();
  public currentBusinessUnit$: Subject<IBusinessUnit> = new Subject<IBusinessUnit>();
  public loading$: Subject<boolean> = new Subject<boolean>();



  public print() {
    console.log("------------- Data Store Dump -------------");
    console.log("BUs", this.businessUnits);
    console.log("currentBu", this.currentBusinessUnit);
    console.log("AppUser", this.currentUser);
    console.log("Nav Items", this.navItems);

    console.log("------------- Data Store Dump (DEAL) -------------");
    console.log("Selected Deal", this.selectedDeal);
  }
}
